import { render } from "./DeveloperCell.vue?vue&type=template&id=0a9b5ff3"
import script from "./DeveloperCell.vue?vue&type=script&lang=js"
export * from "./DeveloperCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__